import { Store } from '@ngrx/store';
import { Option } from '@sapphire/result';
import { combineLatest, filter, map, Observable, take } from 'rxjs';

import {
  selectRootSurvey,
  selectRootSurveyError,
  selectRootSurveyId,
} from '../../state/core/survey-creation-core.selectors';
import {
  SurveyLoadOutcome,
  surveyLoadOutcome,
} from '../domain/survey-load-outcome';

/**
 * Waits for the store to settle on the survey with this id, whichever way the
 * load goes, and emits that outcome once. Unsubscribing, as a cancelled
 * navigation does, stops the wait.
 */
export function awaitSurveyLoad(
  store: Store,
  surveyId: number,
): Observable<SurveyLoadOutcome> {
  return combineLatest([
    store.select(selectRootSurveyId),
    store.select(selectRootSurvey),
    store.select(selectRootSurveyError),
  ]).pipe(
    map(([rootSurveyId, survey, error]) =>
      surveyLoadOutcome(surveyId, {
        rootSurveyId,
        survey: Option.from(survey),
        error,
      }),
    ),
    filter((outcome) => outcome.isSome()),
    map((outcome) => outcome.unwrap()),
    take(1),
  );
}
